export const IDLE_STATUS = 'idle'; // fetching not started yet
export const LOADING_STATUS = 'loading'; // currently fetching the data
export const SUCCESS_STATUS = 'success'; // data fetched successfully
export const FAILURE_STATUS = 'failure'; // data failed to fetch
const statuses = [
  IDLE_STATUS,
  LOADING_STATUS,
  SUCCESS_STATUS,
  FAILURE_STATUS,
] as const;
export type LoadingType = typeof statuses[number];
export const checkIsLoading = (status: LoadingType): boolean =>
  status === LOADING_STATUS;
export const checkIsFinished = (status: LoadingType): boolean =>
  status === SUCCESS_STATUS || status === FAILURE_STATUS;

export enum InterviewStatuses {
  Pending,
  Approved,
  Rejected,
  Cancelled,
  Done,
}

export enum QuestionStatuses {
  Draft,
  Answer,
}
